export default "__VITE_ASSET__CRroUeRX__"